/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function getContractListQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getContractListInput(queryResultSettings: IQueryResultSettings, accountNum: string): IDataServiceRequest {
    const query = getContractListQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetContractList',
        false,
        DataServiceEntities.ContractListEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IContractListEntity' },
        {
            accountNum: accountNum
        }
    );
}

export function getContractListAsync(context: IContext, accountNum: string): AsyncResult<DataServiceEntities.IContractListEntity[]> {
    const request = getContractListInput(context.queryResultSettings || {}, accountNum);
    return callActionOrExecute<DataServiceEntities.IContractListEntity[]>(request, context.callerContext);
}

function getAdvancedNotesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getAdvancedNotesInput(queryResultSettings: IQueryResultSettings, itemIds: string[]): IDataServiceRequest {
    const query = getAdvancedNotesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAdvancedNotes',
        true,
        DataServiceEntities.AdvancedNoteEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAdvancedNoteEntity' },
        {
            itemIds: itemIds
        }
    );
}

export function getAdvancedNotesAsync(context: IContext, itemIds: string[]): AsyncResult<DataServiceEntities.IAdvancedNoteEntity[]> {
    const request = getAdvancedNotesInput(context.queryResultSettings || {}, itemIds);
    return callActionOrExecute<DataServiceEntities.IAdvancedNoteEntity[]>(request, context.callerContext);
}

function getAllowableFreightStatusLineQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getAllowableFreightStatusLineInput(queryResultSettings: IQueryResultSettings, itemIds: string[]): IDataServiceRequest {
    const query = getAllowableFreightStatusLineQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllowableFreightStatusLine',
        true,
        '',
        'true',
        { bypassCache: 'get', returnEntity: '' },
        {
            ItemIds: itemIds
        }
    );
}

export function getAllowableFreightStatusLineAsync(context: IContext, itemIds: string[]): AsyncResult<string[]> {
    const request = getAllowableFreightStatusLineInput(context.queryResultSettings || {}, itemIds);
    return callActionOrExecute<string[]>(request, context.callerContext);
}

function getAllowableFreightQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getAllowableFreightInput(cartId: string): IDataServiceRequest {
    const query = getAllowableFreightQuery();
    return query.createDataServiceRequestForOperation(
        'GetAllowableFreight',
        false,
        DataServiceEntities.AllowableFreightCalculationExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAllowableFreightCalculation' },
        {
            cartId: cartId
        }
    );
}

export function getAllowableFreightAsync(context: IContext, cartId: string): AsyncResult<DataServiceEntities.IAllowableFreightCalculation> {
    const request = getAllowableFreightInput(cartId);
    return callActionOrExecute<DataServiceEntities.IAllowableFreightCalculation>(request, context.callerContext);
}

function getCourseDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCourseDataInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = getCourseDataQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCourseData',
        false,
        DataServiceEntities.CourseResponseEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICourseResponseEntity' },
        {}
    );
}

export function getCourseDataAsync(context: IContext): AsyncResult<DataServiceEntities.ICourseResponseEntity[]> {
    const request = getCourseDataInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.ICourseResponseEntity[]>(request, context.callerContext);
}

function addCourseToCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function addCourseToCartInput(cartId: string, courseId: string): IDataServiceRequest {
    const query = addCourseToCartQuery();
    return query.createDataServiceRequestForOperation(
        'AddCourseToCart',
        false,
        DataServiceEntities.AddCourseToCartResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAddCourseToCartResponse' },
        {
            cartId: cartId,
            courseId: courseId
        }
    );
}

export function addCourseToCartAsync(
    context: IContext,
    cartId: string,
    courseId: string
): AsyncResult<DataServiceEntities.IAddCourseToCartResponse> {
    const request = addCourseToCartInput(cartId, courseId);
    return callActionOrExecute<DataServiceEntities.IAddCourseToCartResponse>(request, context.callerContext);
}

function calculateSurchargeQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function calculateSurchargeInput(cartId: string, tenderTypeId: number): IDataServiceRequest {
    const query = calculateSurchargeQuery();
    return query.createDataServiceRequestForOperation(
        'CalculateSurcharge',
        true,
        DataServiceEntities.CalculateSurchargeResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICalculateSurchargeResponse' },
        {
            cartId: cartId,
            tenderTypeId: tenderTypeId
        }
    );
}

export function calculateSurchargeAsync(
    context: IContext,
    cartId: string,
    tenderTypeId: number
): AsyncResult<DataServiceEntities.ICalculateSurchargeResponse> {
    const request = calculateSurchargeInput(cartId, tenderTypeId);
    return callActionOrExecute<DataServiceEntities.ICalculateSurchargeResponse>(request, context.callerContext);
}

function getReportsExportQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getReportsExportInput(): IDataServiceRequest {
    const query = getReportsExportQuery();
    return query.createDataServiceRequestForOperation('GetReportsExport', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function getReportsExportAsync(context: IContext): AsyncResult<boolean> {
    const request = getReportsExportInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function getPOValidationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getPOValidationInput(poNumber: string): IDataServiceRequest {
    const query = getPOValidationQuery();
    return query.createDataServiceRequestForOperation(
        'GetPOValidation',
        true,
        DataServiceEntities.ValidatePoNumberResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IValidatePoNumberResponse' },
        {
            poNumber: poNumber
        }
    );
}

export function getPOValidationAsync(context: IContext, poNumber: string): AsyncResult<DataServiceEntities.IValidatePoNumberResponse> {
    const request = getPOValidationInput(poNumber);
    return callActionOrExecute<DataServiceEntities.IValidatePoNumberResponse>(request, context.callerContext);
}

function getPOValidation_V2Query(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getPOValidation_V2Input(poNumber: string): IDataServiceRequest {
    const query = getPOValidation_V2Query();
    return query.createDataServiceRequestForOperation(
        'GetPOValidation_V2',
        true,
        DataServiceEntities.ValidatePoNumberResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IValidatePoNumberResponse' },
        {
            poNumber: poNumber
        }
    );
}

export function getPOValidation_V2Async(context: IContext, poNumber: string): AsyncResult<DataServiceEntities.IValidatePoNumberResponse> {
    const request = getPOValidation_V2Input(poNumber);
    return callActionOrExecute<DataServiceEntities.IValidatePoNumberResponse>(request, context.callerContext);
}

function getSalesOrderTrackingNumberQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSalesOrderTrackingNumberInput(salesId: string): IDataServiceRequest {
    const query = getSalesOrderTrackingNumberQuery();
    return query.createDataServiceRequestForOperation(
        'GetSalesOrderTrackingNumber',
        true,
        DataServiceEntities.GetSalesOrderTrackingNumberResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetSalesOrderTrackingNumberResponse' },
        {
            salesId: salesId
        }
    );
}

export function getSalesOrderTrackingNumberAsync(
    context: IContext,
    salesId: string
): AsyncResult<DataServiceEntities.IGetSalesOrderTrackingNumberResponse> {
    const request = getSalesOrderTrackingNumberInput(salesId);
    return callActionOrExecute<DataServiceEntities.IGetSalesOrderTrackingNumberResponse>(request, context.callerContext);
}

function getOrderDetailsAdditionalInformationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getOrderDetailsAdditionalInformationInput(salesId: string): IDataServiceRequest {
    const query = getOrderDetailsAdditionalInformationQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrderDetailsAdditionalInformation',
        true,
        DataServiceEntities.GetOrderDetailsAdditionalInformationResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetOrderDetailsAdditionalInformationResponse' },
        {
            salesId: salesId
        }
    );
}

export function getOrderDetailsAdditionalInformationAsync(
    context: IContext,
    salesId: string
): AsyncResult<DataServiceEntities.IGetOrderDetailsAdditionalInformationResponse> {
    const request = getOrderDetailsAdditionalInformationInput(salesId);
    return callActionOrExecute<DataServiceEntities.IGetOrderDetailsAdditionalInformationResponse>(request, context.callerContext);
}

function getSalesOrderDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSalesOrderDetailsInput(salesIds: string[]): IDataServiceRequest {
    const query = getSalesOrderDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetSalesOrderDetails',
        true,
        DataServiceEntities.GetSalesOrdersadditionalDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetSalesOrdersadditionalDetailsResponse' },
        {
            salesIds: salesIds
        }
    );
}

export function getSalesOrderDetailsAsync(
    context: IContext,
    salesIds: string[]
): AsyncResult<DataServiceEntities.IGetSalesOrdersadditionalDetailsResponse> {
    const request = getSalesOrderDetailsInput(salesIds);
    return callActionOrExecute<DataServiceEntities.IGetSalesOrdersadditionalDetailsResponse>(request, context.callerContext);
}

function getGdnInvoiceDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getGdnInvoiceDetailsInput(invoiceId: string): IDataServiceRequest {
    const query = getGdnInvoiceDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetGdnInvoiceDetails',
        true,
        DataServiceEntities.GetGdnInvoiceDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetGdnInvoiceDetailsResponse' },
        {
            invoiceId: invoiceId
        }
    );
}

export function getGdnInvoiceDetailsAsync(
    context: IContext,
    invoiceId: string
): AsyncResult<DataServiceEntities.IGetGdnInvoiceDetailsResponse> {
    const request = getGdnInvoiceDetailsInput(invoiceId);
    return callActionOrExecute<DataServiceEntities.IGetGdnInvoiceDetailsResponse>(request, context.callerContext);
}

function getGdnPaidInvoiceDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getGdnPaidInvoiceDetailsInput(invoiceIdList: string): IDataServiceRequest {
    const query = getGdnPaidInvoiceDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetGdnPaidInvoiceDetails',
        true,
        DataServiceEntities.GetGdnPaidInvoiceDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetGdnPaidInvoiceDetailsResponse' },
        {
            invoiceIdList: invoiceIdList
        }
    );
}

export function getGdnPaidInvoiceDetailsAsync(
    context: IContext,
    invoiceIdList: string
): AsyncResult<DataServiceEntities.IGetGdnPaidInvoiceDetailsResponse> {
    const request = getGdnPaidInvoiceDetailsInput(invoiceIdList);
    return callActionOrExecute<DataServiceEntities.IGetGdnPaidInvoiceDetailsResponse>(request, context.callerContext);
}

function getGdnOpenInvoiceDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getGdnOpenInvoiceDetailsInput(): IDataServiceRequest {
    const query = getGdnOpenInvoiceDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetGdnOpenInvoiceDetails',
        true,
        DataServiceEntities.GetGdnOpenInvoiceDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse' },
        {}
    );
}

export function getGdnOpenInvoiceDetailsAsync(context: IContext): AsyncResult<DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse> {
    const request = getGdnOpenInvoiceDetailsInput();
    return callActionOrExecute<DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse>(request, context.callerContext);
}

function getGdnOpenInvoiceDetails_V2Query(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getGdnOpenInvoiceDetails_V2Input(
    isCreditNotesIncluded: boolean,
    isFreeTextCreditNotesIncluded: boolean
): IDataServiceRequest {
    const query = getGdnOpenInvoiceDetails_V2Query();
    return query.createDataServiceRequestForOperation(
        'GetGdnOpenInvoiceDetails_V2',
        true,
        DataServiceEntities.GetGdnOpenInvoiceDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse' },
        {
            isCreditNotesIncluded: isCreditNotesIncluded,
            isFreeTextCreditNotesIncluded: isFreeTextCreditNotesIncluded
        }
    );
}

export function getGdnOpenInvoiceDetails_V2Async(
    context: IContext,
    isCreditNotesIncluded: boolean,
    isFreeTextCreditNotesIncluded: boolean
): AsyncResult<DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse> {
    const request = getGdnOpenInvoiceDetails_V2Input(isCreditNotesIncluded, isFreeTextCreditNotesIncluded);
    return callActionOrExecute<DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse>(request, context.callerContext);
}

function getGdnOpenInvoiceDetails_V3Query(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getGdnOpenInvoiceDetails_V3Input(
    isCreditNotesIncluded: boolean,
    isFreeTextCreditNotesIncluded: boolean,
    isProjectCreditNoteIncluded: boolean
): IDataServiceRequest {
    const query = getGdnOpenInvoiceDetails_V3Query();
    return query.createDataServiceRequestForOperation(
        'GetGdnOpenInvoiceDetails_V3',
        true,
        DataServiceEntities.GetGdnOpenInvoiceDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse' },
        {
            isCreditNotesIncluded: isCreditNotesIncluded,
            isFreeTextCreditNotesIncluded: isFreeTextCreditNotesIncluded,
            isProjectCreditNoteIncluded: isProjectCreditNoteIncluded
        }
    );
}

export function getGdnOpenInvoiceDetails_V3Async(
    context: IContext,
    isCreditNotesIncluded: boolean,
    isFreeTextCreditNotesIncluded: boolean,
    isProjectCreditNoteIncluded: boolean
): AsyncResult<DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse> {
    const request = getGdnOpenInvoiceDetails_V3Input(isCreditNotesIncluded, isFreeTextCreditNotesIncluded, isProjectCreditNoteIncluded);
    return callActionOrExecute<DataServiceEntities.IGetGdnOpenInvoiceDetailsResponse>(request, context.callerContext);
}

function getGdnPastDueInvoiceDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getGdnPastDueInvoiceDetailsInput(invoiceIds: string[], pageNumber: number, pageSize: number): IDataServiceRequest {
    const query = getGdnPastDueInvoiceDetailsQuery();
    return query.createDataServiceRequestForOperation(
        'GetGdnPastDueInvoiceDetails',
        true,
        DataServiceEntities.GetGdnPastDueInvoiceDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetGdnPastDueInvoiceDetailsResponse' },
        {
            invoiceIds: invoiceIds,
            pageNumber: pageNumber,
            pageSize: pageSize
        }
    );
}

export function getGdnPastDueInvoiceDetailsAsync(
    context: IContext,
    invoiceIds: string[],
    pageNumber: number,
    pageSize: number
): AsyncResult<DataServiceEntities.IGetGdnPastDueInvoiceDetailsResponse> {
    const request = getGdnPastDueInvoiceDetailsInput(invoiceIds, pageNumber, pageSize);
    return callActionOrExecute<DataServiceEntities.IGetGdnPastDueInvoiceDetailsResponse>(request, context.callerContext);
}

function getBackOrderListQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getBackOrderListInput(top: number, skip: number, selectedSort: string, sortOrder: string): IDataServiceRequest {
    const query = getBackOrderListQuery();
    return query.createDataServiceRequestForOperation(
        'GetBackOrderList',
        false,
        DataServiceEntities.GetBackOrderListResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetBackOrderListResponse' },
        {
            top: top,
            skip: skip,
            selectedSort: selectedSort,
            sortOrder: sortOrder
        }
    );
}

export function getBackOrderListAsync(
    context: IContext,
    top: number,
    skip: number,
    selectedSort: string,
    sortOrder: string
): AsyncResult<DataServiceEntities.IGetBackOrderListResponse> {
    const request = getBackOrderListInput(top, skip, selectedSort, sortOrder);
    return callActionOrExecute<DataServiceEntities.IGetBackOrderListResponse>(request, context.callerContext);
}

function getSalesReportQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getSalesReportInput(searchType: string): IDataServiceRequest {
    const query = getSalesReportQuery();
    return query.createDataServiceRequestForOperation(
        'GetSalesReport',
        true,
        DataServiceEntities.SalesReportResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISalesReportResponseEntity' },
        {
            searchType: searchType
        }
    );
}

export function getSalesReportAsync(context: IContext, searchType: string): AsyncResult<DataServiceEntities.ISalesReportResponseEntity> {
    const request = getSalesReportInput(searchType);
    return callActionOrExecute<DataServiceEntities.ISalesReportResponseEntity>(request, context.callerContext);
}

function getPriceOrderQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getPriceOrderInput(): IDataServiceRequest {
    const query = getPriceOrderQuery();
    return query.createDataServiceRequestForOperation('GetPriceOrder', true, '', 'false', { bypassCache: 'get', returnEntity: '' }, {});
}

export function getPriceOrderAsync(context: IContext): AsyncResult<boolean> {
    const request = getPriceOrderInput();
    return callActionOrExecute<boolean>(request, context.callerContext);
}

function getPriceByManufacturerQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getPriceByManufacturerInput(mfrCodeList: string): IDataServiceRequest {
    const query = getPriceByManufacturerQuery();
    return query.createDataServiceRequestForOperation(
        'GetPriceByManufacturer',
        true,
        DataServiceEntities.PriceByManufacturerResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPriceByManufacturerResponseEntity' },
        {
            mfrCodeList: mfrCodeList
        }
    );
}

export function getPriceByManufacturerAsync(
    context: IContext,
    mfrCodeList: string
): AsyncResult<DataServiceEntities.IPriceByManufacturerResponseEntity> {
    const request = getPriceByManufacturerInput(mfrCodeList);
    return callActionOrExecute<DataServiceEntities.IPriceByManufacturerResponseEntity>(request, context.callerContext);
}

function getDealerLocationsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getDealerLocationsInput(
    queryResultSettings: IQueryResultSettings,
    useChannelMfr: boolean,
    latitude: number,
    longitude: number,
    distanceInMiles: number
): IDataServiceRequest {
    const query = getDealerLocationsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetDealerLocations',
        false,
        DataServiceEntities.DealerLocationEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDealerLocationEntity' },
        {
            useChannelMfr: useChannelMfr,
            latitude: latitude,
            longitude: longitude,
            distanceInMiles: distanceInMiles
        }
    );
}

export function getDealerLocationsAsync(
    context: IContext,
    useChannelMfr: boolean,
    latitude: number,
    longitude: number,
    distanceInMiles: number
): AsyncResult<DataServiceEntities.IDealerLocationEntity[]> {
    const request = getDealerLocationsInput(context.queryResultSettings || {}, useChannelMfr, latitude, longitude, distanceInMiles);
    return callActionOrExecute<DataServiceEntities.IDealerLocationEntity[]>(request, context.callerContext);
}

function getDealerDetailsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getDealerDetailsInput(queryResultSettings: IQueryResultSettings, dealerId: string): IDataServiceRequest {
    const query = getDealerDetailsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetDealerDetails',
        false,
        DataServiceEntities.DealerEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDealerEntity' },
        {
            dealerId: dealerId
        }
    );
}

export function getDealerDetailsAsync(context: IContext, dealerId: string): AsyncResult<DataServiceEntities.IDealerEntity[]> {
    const request = getDealerDetailsInput(context.queryResultSettings || {}, dealerId);
    return callActionOrExecute<DataServiceEntities.IDealerEntity[]>(request, context.callerContext);
}

function getProductEligibilityQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductEligibilityInput(
    queryResultSettings: IQueryResultSettings,
    itemIds: string[],
    addressId: number,
    cartId: string
): IDataServiceRequest {
    const query = getProductEligibilityQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductEligibility',
        true,
        DataServiceEntities.EligibilityItemExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IEligibilityItem' },
        {
            itemIds: itemIds,
            addressId: addressId,
            cartId: cartId
        }
    );
}

export function getProductEligibilityAsync(
    context: IContext,
    itemIds: string[],
    addressId: number,
    cartId: string
): AsyncResult<DataServiceEntities.IEligibilityItem[]> {
    const request = getProductEligibilityInput(context.queryResultSettings || {}, itemIds, addressId, cartId);
    return callActionOrExecute<DataServiceEntities.IEligibilityItem[]>(request, context.callerContext);
}

function getProductEligibilityV2Query(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductEligibilityV2Input(
    queryResultSettings: IQueryResultSettings,
    itemIds: string[],
    countryId: string,
    stateId: string,
    regionId: string,
    cartId: string,
    isCheckout: boolean
): IDataServiceRequest {
    const query = getProductEligibilityV2Query().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductEligibilityV2',
        true,
        DataServiceEntities.EligibilityItemExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IEligibilityItem' },
        {
            itemIds: itemIds,
            countryId: countryId,
            stateId: stateId,
            regionId: regionId,
            cartId: cartId,
            isCheckout: isCheckout
        }
    );
}

export function getProductEligibilityV2Async(
    context: IContext,
    itemIds: string[],
    countryId: string,
    stateId: string,
    regionId: string,
    cartId: string,
    isCheckout: boolean
): AsyncResult<DataServiceEntities.IEligibilityItem[]> {
    const request = getProductEligibilityV2Input(
        context.queryResultSettings || {},
        itemIds,
        countryId,
        stateId,
        regionId,
        cartId,
        isCheckout
    );
    return callActionOrExecute<DataServiceEntities.IEligibilityItem[]>(request, context.callerContext);
}

function getTableQueryResponseQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getTableQueryResponseInput(
    schemaName: string,
    tableName: string,
    columns: string[],
    whereClauses: DataServiceEntities.IWhereClause[],
    orderBy: string,
    isDescending: boolean,
    limit: number,
    offset: number,
    password: string
): IDataServiceRequest {
    const query = getTableQueryResponseQuery();
    return query.createDataServiceRequestForOperation(
        'GetTableQueryResponse',
        true,
        DataServiceEntities.TableQueryResponseEntityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ITableQueryResponseEntity' },
        {
            schemaName: schemaName,
            tableName: tableName,
            columns: columns,
            whereClauses: whereClauses,
            orderBy: orderBy,
            isDescending: isDescending,
            limit: limit,
            offset: offset,
            password: password
        }
    );
}

export function getTableQueryResponseAsync(
    context: IContext,
    schemaName: string,
    tableName: string,
    columns: string[],
    whereClauses: DataServiceEntities.IWhereClause[],
    orderBy: string,
    isDescending: boolean,
    limit: number,
    offset: number,
    password: string
): AsyncResult<DataServiceEntities.ITableQueryResponseEntity> {
    const request = getTableQueryResponseInput(
        schemaName,
        tableName,
        columns,
        whereClauses,
        orderBy,
        isDescending,
        limit,
        offset,
        password
    );
    return callActionOrExecute<DataServiceEntities.ITableQueryResponseEntity>(request, context.callerContext);
}

function getInventoryLevelRangesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInventoryLevelRangesInput(queryResultSettings: IQueryResultSettings, itemIds: string[]): IDataServiceRequest {
    const query = getInventoryLevelRangesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetInventoryLevelRanges',
        true,
        DataServiceEntities.ProfileDataMapExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProfileDataMap' },
        {
            itemIds: itemIds
        }
    );
}

export function getInventoryLevelRangesAsync(context: IContext, itemIds: string[]): AsyncResult<DataServiceEntities.IProfileDataMap[]> {
    const request = getInventoryLevelRangesInput(context.queryResultSettings || {}, itemIds);
    return callActionOrExecute<DataServiceEntities.IProfileDataMap[]>(request, context.callerContext);
}

function eveSearchCustomerByAccountIdQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function eveSearchCustomerByAccountIdInput(accountNumber: string): IDataServiceRequest {
    const query = eveSearchCustomerByAccountIdQuery();
    return query.createDataServiceRequestForOperation(
        'EveSearchCustomerByAccountId',
        true,
        DataServiceEntities.SearchCustomerByAccountIdResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISearchCustomerByAccountIdResponse' },
        {
            accountNumber: accountNumber
        }
    );
}

export function eveSearchCustomerByAccountIdAsync(
    context: IContext,
    accountNumber: string
): AsyncResult<DataServiceEntities.ISearchCustomerByAccountIdResponse> {
    const request = eveSearchCustomerByAccountIdInput(accountNumber);
    return callActionOrExecute<DataServiceEntities.ISearchCustomerByAccountIdResponse>(request, context.callerContext);
}

function getInvoicePaymentSchedulesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getInvoicePaymentSchedulesInput(queryResultSettings: IQueryResultSettings, invoiceIds: string[]): IDataServiceRequest {
    const query = getInvoicePaymentSchedulesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetInvoicePaymentSchedules',
        true,
        DataServiceEntities.InvoicePaymentScheduleEntityExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IInvoicePaymentScheduleEntity' },
        {
            invoiceIds: invoiceIds
        }
    );
}

export function getInvoicePaymentSchedulesAsync(
    context: IContext,
    invoiceIds: string[]
): AsyncResult<DataServiceEntities.IInvoicePaymentScheduleEntity[]> {
    const request = getInvoicePaymentSchedulesInput(context.queryResultSettings || {}, invoiceIds);
    return callActionOrExecute<DataServiceEntities.IInvoicePaymentScheduleEntity[]>(request, context.callerContext);
}

function addInvoicesToCartQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function addInvoicesToCartInput(invoiceAmounts: DataServiceEntities.IInvoiceAmountEntity[], cartId: string): IDataServiceRequest {
    const query = addInvoicesToCartQuery();
    return query.createDataServiceRequestForOperation(
        'AddInvoicesToCart',
        true,
        DataServiceEntities.AddInvoicesWithAmountsToCartResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAddInvoicesWithAmountsToCartResponse' },
        {
            invoiceAmounts: invoiceAmounts,
            cartId: cartId
        }
    );
}

export function addInvoicesToCartAsync(
    context: IContext,
    invoiceAmounts: DataServiceEntities.IInvoiceAmountEntity[],
    cartId: string
): AsyncResult<DataServiceEntities.IAddInvoicesWithAmountsToCartResponse> {
    const request = addInvoicesToCartInput(invoiceAmounts, cartId);
    return callActionOrExecute<DataServiceEntities.IAddInvoicesWithAmountsToCartResponse>(request, context.callerContext);
}

function getProductCodesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductCodesInput(itemIds: string[]): IDataServiceRequest {
    const query = getProductCodesQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductCodes',
        true,
        DataServiceEntities.GetProductCodesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetProductCodesResponse' },
        {
            itemIds: itemIds
        }
    );
}

export function getProductCodesAsync(context: IContext, itemIds: string[]): AsyncResult<DataServiceEntities.IGetProductCodesResponse> {
    const request = getProductCodesInput(itemIds);
    return callActionOrExecute<DataServiceEntities.IGetProductCodesResponse>(request, context.callerContext);
}

// @ts-ignore
function orderUploadQuery(recId?: number): DataServiceQuery {
    const key = recId ? { RecId: recId } : null;
    return new DataServiceQuery(
        'OrderUpload',
        'OrderUploadResponseEntity',
        DataServiceEntities.OrderUploadResponseEntityExtensionClass,
        key
    );
}

export function createGetProductsByManufacturerItemIdInput(
    queryResultSettings: IQueryResultSettings,
    itemIds: string[],
    manufacturerCode: string
): IDataServiceRequest {
    const query = orderUploadQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProductsByManufacturerItemId',
        true,
        DataServiceEntities.SearchTextProductMapExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ISearchTextProductMap' },
        { itemIds: itemIds, manufacturerCode: manufacturerCode }
    );
}

export function getProductsByManufacturerItemIdAsync(
    context: IContext,
    itemIds: string[],
    manufacturerCode: string
): AsyncResult<DataServiceEntities.ISearchTextProductMap[]> {
    const request = createGetProductsByManufacturerItemIdInput(context.queryResultSettings || {}, itemIds, manufacturerCode);
    return callActionOrExecute<DataServiceEntities.ISearchTextProductMap[]>(request, context.callerContext);
}

export function createGetManufacturerCodeInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = orderUploadQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetManufacturerCode',
        false,
        DataServiceEntities.ManufacturerCodeResponseEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IManufacturerCodeResponseEntity' },
        {}
    );
}

export function getManufacturerCodeAsync(context: IContext): AsyncResult<DataServiceEntities.IManufacturerCodeResponseEntity[]> {
    const request = createGetManufacturerCodeInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IManufacturerCodeResponseEntity[]>(request, context.callerContext);
}

// @ts-ignore
function ariQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('Ari', 'AriModelEntity', DataServiceEntities.AriModelEntityExtensionClass, key);
}

export function createGetModelsForBySearchTermInput(
    queryResultSettings: IQueryResultSettings,
    searchTerm: string,
    isRefineEnabled: boolean
): IDataServiceRequest {
    const query = ariQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetModelsForBySearchTerm',
        true,
        DataServiceEntities.AriModelResponseEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAriModelResponseEntity' },
        { searchTerm: searchTerm, isRefineEnabled: isRefineEnabled }
    );
}

export function getModelsForBySearchTermAsync(
    context: IContext,
    searchTerm: string,
    isRefineEnabled: boolean
): AsyncResult<DataServiceEntities.IAriModelResponseEntity[]> {
    const request = createGetModelsForBySearchTermInput(context.queryResultSettings || {}, searchTerm, isRefineEnabled);
    return callActionOrExecute<DataServiceEntities.IAriModelResponseEntity[]>(request, context.callerContext);
}

export function createGetModelsForBySearchTermV2Input(
    queryResultSettings: IQueryResultSettings,
    searchTerm: string,
    brandCodes: string[],
    isRefineEnabled: boolean
): IDataServiceRequest {
    const query = ariQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetModelsForBySearchTermV2',
        true,
        DataServiceEntities.AriModelResponseEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAriModelResponseEntity' },
        { searchTerm: searchTerm, brandCodes: brandCodes, isRefineEnabled: isRefineEnabled }
    );
}

export function getModelsForBySearchTermV2Async(
    context: IContext,
    searchTerm: string,
    brandCodes: string[],
    isRefineEnabled: boolean
): AsyncResult<DataServiceEntities.IAriModelResponseEntity[]> {
    const request = createGetModelsForBySearchTermV2Input(context.queryResultSettings || {}, searchTerm, brandCodes, isRefineEnabled);
    return callActionOrExecute<DataServiceEntities.IAriModelResponseEntity[]>(request, context.callerContext);
}

export function createGetPartSmartPortalAccessInput(isSobo: boolean): IDataServiceRequest {
    const query = ariQuery();
    return query.createDataServiceRequestForOperation(
        'GetPartSmartPortalAccess',
        true,
        DataServiceEntities.GetPartSmartTokenResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetPartSmartTokenResponse' },
        { isSobo: isSobo }
    );
}

export function getPartSmartPortalAccessAsync(
    context: IContext,
    isSobo: boolean
): AsyncResult<DataServiceEntities.IGetPartSmartTokenResponse> {
    const request = createGetPartSmartPortalAccessInput(isSobo);
    return callActionOrExecute<DataServiceEntities.IGetPartSmartTokenResponse>(request, context.callerContext);
}

export function createGetAriAssemblyListInput(
    queryResultSettings: IQueryResultSettings,
    brandCode: string,
    modelId: number
): IDataServiceRequest {
    const query = ariQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAriAssemblyList',
        false,
        DataServiceEntities.AriServiceModelAssemblySearchExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAriServiceModelAssemblySearch' },
        { brandCode: brandCode, modelId: modelId }
    );
}

export function getAriAssemblyListAsync(
    context: IContext,
    brandCode: string,
    modelId: number
): AsyncResult<DataServiceEntities.IAriServiceModelAssemblySearch[]> {
    const request = createGetAriAssemblyListInput(context.queryResultSettings || {}, brandCode, modelId);
    return callActionOrExecute<DataServiceEntities.IAriServiceModelAssemblySearch[]>(request, context.callerContext);
}

export function createGetAriAssemblyDetailsInput(brandCode: string, modelId: number, assemblyId: number): IDataServiceRequest {
    const query = ariQuery();
    return query.createDataServiceRequestForOperation(
        'GetAriAssemblyDetails',
        false,
        DataServiceEntities.AriServiceAssemblyInformationExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IAriServiceAssemblyInformation' },
        { brandCode: brandCode, modelId: modelId, assemblyId: assemblyId }
    );
}

export function getAriAssemblyDetailsAsync(
    context: IContext,
    brandCode: string,
    modelId: number,
    assemblyId: number
): AsyncResult<DataServiceEntities.IAriServiceAssemblyInformation> {
    const request = createGetAriAssemblyDetailsInput(brandCode, modelId, assemblyId);
    return callActionOrExecute<DataServiceEntities.IAriServiceAssemblyInformation>(request, context.callerContext);
}

export function createGetManufacturerBrandNameInput(queryResultSettings: IQueryResultSettings, mfrBrandCode: string): IDataServiceRequest {
    const query = ariQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetManufacturerBrandName',
        false,
        DataServiceEntities.ManufacturerBrandNameResponseEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IManufacturerBrandNameResponseEntity' },
        { mfrBrandCode: mfrBrandCode }
    );
}

export function getManufacturerBrandNameAsync(
    context: IContext,
    mfrBrandCode: string
): AsyncResult<DataServiceEntities.IManufacturerBrandNameResponseEntity[]> {
    const request = createGetManufacturerBrandNameInput(context.queryResultSettings || {}, mfrBrandCode);
    return callActionOrExecute<DataServiceEntities.IManufacturerBrandNameResponseEntity[]>(request, context.callerContext);
}

// @ts-ignore
function supersessionQuery(productId?: number): DataServiceQuery {
    const key = productId ? { ProductId: productId } : null;
    return new DataServiceQuery(
        'Supersession',
        'SupersessionResponseEntity',
        DataServiceEntities.SupersessionResponseEntityExtensionClass,
        key
    );
}

export function createGetSupersessionInput(
    queryResultSettings: IQueryResultSettings,
    itemIds: string[],
    productIds: number[]
): IDataServiceRequest {
    const query = supersessionQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSupersession',
        true,
        EntityClasses.SimpleProductClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.SimpleProduct' },
        { itemIds: itemIds, productIds: productIds }
    );
}

export function getSupersessionAsync(context: IContext, itemIds: string[], productIds: number[]): AsyncResult<Entities.SimpleProduct[]> {
    const request = createGetSupersessionInput(context.queryResultSettings || {}, itemIds, productIds);
    return callActionOrExecute<Entities.SimpleProduct[]>(request, context.callerContext);
}

export function createGetSupersessionV2Input(
    queryResultSettings: IQueryResultSettings,
    itemIds: string[],
    productIds: number[],
    disableSupersession: boolean,
    cartId: string
): IDataServiceRequest {
    const query = supersessionQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetSupersessionV2',
        true,
        EntityClasses.SimpleProductClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.SimpleProduct' },
        { itemIds: itemIds, productIds: productIds, disableSupersession: disableSupersession, cartId: cartId }
    );
}

export function getSupersessionV2Async(
    context: IContext,
    itemIds: string[],
    productIds: number[],
    disableSupersession: boolean,
    cartId: string
): AsyncResult<Entities.SimpleProduct[]> {
    const request = createGetSupersessionV2Input(context.queryResultSettings || {}, itemIds, productIds, disableSupersession, cartId);
    return callActionOrExecute<Entities.SimpleProduct[]>(request, context.callerContext);
}

export function createGetCustFreightTermCodeInput(): IDataServiceRequest {
    const query = supersessionQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustFreightTermCode',
        true,
        DataServiceEntities.GetCustFreightTermCodeResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetCustFreightTermCodeResponse' },
        {}
    );
}

export function getCustFreightTermCodeAsync(context: IContext): AsyncResult<DataServiceEntities.IGetCustFreightTermCodeResponse> {
    const request = createGetCustFreightTermCodeInput();
    return callActionOrExecute<DataServiceEntities.IGetCustFreightTermCodeResponse>(request, context.callerContext);
}

export function createGetCustFreightTermCodeV2Input(): IDataServiceRequest {
    const query = supersessionQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustFreightTermCodeV2',
        true,
        DataServiceEntities.GetCustFreightTermCodeResponseV2ExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetCustFreightTermCodeResponseV2' },
        {}
    );
}

export function getCustFreightTermCodeV2Async(context: IContext): AsyncResult<DataServiceEntities.IGetCustFreightTermCodeResponseV2> {
    const request = createGetCustFreightTermCodeV2Input();
    return callActionOrExecute<DataServiceEntities.IGetCustFreightTermCodeResponseV2>(request, context.callerContext);
}

export function createGetGdnAddChargeLineInput(cartId: string, amount: number, chargeCode: string): IDataServiceRequest {
    const query = supersessionQuery();
    return query.createDataServiceRequestForOperation(
        'GetGdnAddChargeLine',
        true,
        DataServiceEntities.GetGdnAddChargeLineResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetGdnAddChargeLineResponse' },
        { cartId: cartId, amount: amount, chargeCode: chargeCode }
    );
}

export function getGdnAddChargeLineAsync(
    context: IContext,
    cartId: string,
    amount: number,
    chargeCode: string
): AsyncResult<DataServiceEntities.IGetGdnAddChargeLineResponse> {
    const request = createGetGdnAddChargeLineInput(cartId, amount, chargeCode);
    return callActionOrExecute<DataServiceEntities.IGetGdnAddChargeLineResponse>(request, context.callerContext);
}

// @ts-ignore
function cartPromotionsQuery(orderTemplateId?: string): DataServiceQuery {
    const key = orderTemplateId ? { OrderTemplateId: orderTemplateId } : null;
    return new DataServiceQuery('CartPromotions', 'CartPromotionsEntity', DataServiceEntities.CartPromotionsEntityExtensionClass, key);
}

export function createGetByOrderTemplateIdInput(orderTemplateId: string): IDataServiceRequest {
    const query = cartPromotionsQuery();
    return query.createDataServiceRequestForOperation(
        'GetByOrderTemplateId',
        true,
        DataServiceEntities.CartPromotionsEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICartPromotionsEntity' },
        { orderTemplateId: orderTemplateId }
    );
}

export function getByOrderTemplateIdAsync(
    context: IContext,
    orderTemplateId: string
): AsyncResult<DataServiceEntities.ICartPromotionsEntity> {
    const request = createGetByOrderTemplateIdInput(orderTemplateId);
    return callActionOrExecute<DataServiceEntities.ICartPromotionsEntity>(request, context.callerContext);
}

export function createSaveInput(cartPromotion: DataServiceEntities.ICartPromotionsEntity): IDataServiceRequest {
    const query = cartPromotionsQuery();
    return query.createDataServiceRequestForOperation(
        'Save',
        true,
        DataServiceEntities.SaveCartPromotionsResponseRSExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISaveCartPromotionsResponseRS' },
        { cartPromotion: cartPromotion }
    );
}

export function saveAsync(
    context: IContext,
    cartPromotion: DataServiceEntities.ICartPromotionsEntity
): AsyncResult<DataServiceEntities.ISaveCartPromotionsResponseRS> {
    const request = createSaveInput(cartPromotion);
    return callActionOrExecute<DataServiceEntities.ISaveCartPromotionsResponseRS>(request, context.callerContext);
}

export function createDeleteByOrderTemplateIdInput(orderTemplateId: string): IDataServiceRequest {
    const query = cartPromotionsQuery();
    return query.createDataServiceRequestForOperation(
        'DeleteByOrderTemplateId',
        true,
        DataServiceEntities.DeleteCartPromotionsByOrderTemplateIdResponseRSExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IDeleteCartPromotionsByOrderTemplateIdResponseRS' },
        { orderTemplateId: orderTemplateId }
    );
}

export function deleteByOrderTemplateIdAsync(
    context: IContext,
    orderTemplateId: string
): AsyncResult<DataServiceEntities.IDeleteCartPromotionsByOrderTemplateIdResponseRS> {
    const request = createDeleteByOrderTemplateIdInput(orderTemplateId);
    return callActionOrExecute<DataServiceEntities.IDeleteCartPromotionsByOrderTemplateIdResponseRS>(request, context.callerContext);
}

export function createGetAllInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = cartPromotionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAll',
        false,
        DataServiceEntities.CartPromotionsEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICartPromotionsEntity' },
        {}
    );
}

export function getAllAsync(context: IContext): AsyncResult<DataServiceEntities.ICartPromotionsEntity[]> {
    const request = createGetAllInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.ICartPromotionsEntity[]>(request, context.callerContext);
}

// @ts-ignore
function checkoutValidationQuery(invoiceAccount?: string): DataServiceQuery {
    const key = invoiceAccount ? { InvoiceAccount: invoiceAccount } : null;
    return new DataServiceQuery('CheckoutValidation', 'InvoiceAccountEntity', DataServiceEntities.InvoiceAccountEntityExtensionClass, key);
}

export function createGetInvoiceAccountInput(): IDataServiceRequest {
    const query = checkoutValidationQuery();
    return query.createDataServiceRequestForOperation(
        'GetInvoiceAccount',
        false,
        DataServiceEntities.GetCheckoutValidationResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetCheckoutValidationResponse' },
        {}
    );
}

export function getInvoiceAccountAsync(context: IContext): AsyncResult<DataServiceEntities.IGetCheckoutValidationResponse> {
    const request = createGetInvoiceAccountInput();
    return callActionOrExecute<DataServiceEntities.IGetCheckoutValidationResponse>(request, context.callerContext);
}

// @ts-ignore
function enhancedDescriptionsQuery(product?: number): DataServiceQuery {
    const key = product ? { Product: product } : null;
    return new DataServiceQuery(
        'EnhancedDescriptions',
        'EnhancedProductDescriptionEntity',
        DataServiceEntities.EnhancedProductDescriptionEntityExtensionClass,
        key
    );
}

export function createGetDescriptionByProductIdInput(id: number): IDataServiceRequest {
    const query = enhancedDescriptionsQuery();
    return query.createDataServiceRequestForOperation(
        'GetDescriptionByProductId',
        false,
        DataServiceEntities.EnhancedProductDescriptionEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IEnhancedProductDescriptionEntity' },
        { id: id }
    );
}

export function getDescriptionByProductIdAsync(
    context: IContext,
    id: number
): AsyncResult<DataServiceEntities.IEnhancedProductDescriptionEntity> {
    const request = createGetDescriptionByProductIdInput(id);
    return callActionOrExecute<DataServiceEntities.IEnhancedProductDescriptionEntity>(request, context.callerContext);
}
